import React from 'react';


export default function ProjectHeader(param) {

    return(
        <div className="content-header">
            <div className="container-fluid">
                <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0 text-dark">프로젝트</h1>
                    </div>
                </div>
            </div>
        </div>
    );
}